<div class="modal-header p-2">
  <h4 class="modal-title">
    <span class="newspaper-name">{{ newsPaperName }}</span>
    -  <span class="text-capitalize">{{ newsPaperDate | date:"EEEE" }}</span> {{ newsPaperDate | date:"d" }} {{ newsPaperDate | date:"MMMM" }} {{ newsPaperDate | date:"y" }}
  </h4>
  <div class="close d-flex align-items-center" (click)="activeModal.dismiss('Cross click')"><span class="me-2">FERMER</span><img src="../../../assets/img/icon-close.png" /></div>
</div>
<div class="modal-body p-0 h-100">
  @if (iFrameCalameoSrc) {
    <div style="text-align:center;" class="h-100">
      <iframe  width="100%" height="100%" frameborder="0" scrolling="no" style="margin:0 auto;"
        allowtransparency allowfullscreen [src]="iFrameCalameoSrc">
      </iframe>
    </div>
  }
</div>
